import { Html, useProgress } from '@react-three/drei';

interface D3LoaderProps {}

export default function D3Loader({}: D3LoaderProps) {
  const { progress } = useProgress();
  return (
    <Html center>
      <div
        style={{
          color: '#1F1F1F',
          background: 'var(--primary-color)',
          borderRadius: '50%',
          height: '50px',
          width: '50px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        {progress === 0 ? 10 : Math.floor(progress)}
      </div>
    </Html>
  );
}
